import React, { useState } from "react";
// import { Card } from "@/components/ui/card";
import Card from './components/Card';

function Section({ id, title, subtitle, children }) {
  return (
    <section id={id} className="py-12 px-4 max-w-6xl mx-auto">
      <h2 className="text-2xl font-bold text-slate-800">{title}</h2>
      {subtitle && <p className="text-slate-600 mt-1">{subtitle}</p>}
      <div className="mt-6">{children}</div>
    </section>
  );
}

export default function App() {
  const year = new Date().getFullYear();
  const [fee, setFee] = useState(0);

  const districts = [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", 
    "Junagadh", "Gandhinagar", "Anand", "Kutch"
  ];

  const printForm = () => window.print();

  return (
    <div className="font-sans bg-slate-50">
      {/* HERO */}
      <header className="bg-gradient-to-r from-blue-700 to-emerald-600 text-white py-16 px-4 text-center">
        <h1 className="text-4xl font-extrabold">Gujarat Association of Hospitals, Nursing Homes & Allied Healthcare</h1>
        <p className="mt-4 text-lg max-w-3xl mx-auto">
          Federation uniting district hospital & nursing home associations across Gujarat for advocacy, quality, and equitable healthcare access.
        </p>
      </header>

      {/* VISION */}
      <Section id="vision" title="Vision" subtitle="Unified voice for Gujarat’s healthcare providers.">
        <Card className="p-6 text-slate-700">
          To represent, support, and empower all private hospitals and nursing homes in Gujarat by fostering collaboration, ensuring quality, and engaging with policymakers.
        </Card>
      </Section>

      {/* MISSION */}
      <Section id="mission" title="Mission" subtitle="Commitment to members and patients.">
        <div className="grid md:grid-cols-2 gap-4">
          <Card className="p-6">Advocacy with state health authorities and regulators.</Card>
          <Card className="p-6">Capacity building through workshops, training, and peer exchange.</Card>
          <Card className="p-6">Facilitating fair health insurance & TPA practices.</Card>
          <Card className="p-6">CEA compliance support and standardization.</Card>
        </div>
      </Section>

      {/* MEMBERSHIP FORM */}
      <Section id="forms" title="Membership Form" subtitle="District associations can apply online.">
        <Card className="p-6">
          <form className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="font-semibold">District <span className="text-red-600">*</span></label>
              <select name="district" className="mt-1 w-full rounded-xl border px-3 py-2">
                <option value="">Select a district</option>
                {districts.map(d => <option key={d}>{d}</option>)}
              </select>
            </div>
            <div>
              <label className="font-semibold">Type of Association <span className="text-red-600">*</span></label>
              <div className="mt-2 flex gap-4 flex-wrap">
                {["Trust", "Society", "AOP"].map(t => (
                  <label key={t} className="inline-flex items-center gap-2">
                    <input type="radio" name="assocType" value={t} /> <span>{t}</span>
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label className="font-semibold">Registration No. / Year</label>
              <input name="regNo" className="mt-1 w-full rounded-xl border px-3 py-2" />
            </div>
            <div>
              <label className="font-semibold">Number of Member Hospitals <span className="text-red-600">*</span></label>
              <input name="members" type="number" min="1" className="mt-1 w-full rounded-xl border px-3 py-2" />
            </div>
            <div>
              <label className="font-semibold">Registered Address</label>
              <input name="address" className="mt-1 w-full rounded-xl border px-3 py-2" />
            </div>
            <div>
              <label className="font-semibold">Primary Contact Person <span className="text-red-600">*</span></label>
              <input name="contactName" className="mt-1 w-full rounded-xl border px-3 py-2" placeholder="Name & designation" />
            </div>
            <div>
              <label className="font-semibold">Email <span className="text-red-600">*</span></label>
              <input name="email" type="email" className="mt-1 w-full rounded-xl border px-3 py-2" />
            </div>
            <div>
              <label className="font-semibold">Phone <span className="text-red-600">*</span></label>
              <input name="phone" type="tel" className="mt-1 w-full rounded-xl border px-3 py-2" placeholder="10-digit number" />
            </div>
            <div>
              <label className="font-semibold">Membership Fee (₹) <span className="text-red-600">*</span></label>
              <input name="feeAmount" type="number" min="0" className="mt-1 w-full rounded-xl border px-3 py-2" onChange={(e)=>setFee(Number(e.target.value||0))} placeholder="As per schedule" />
            </div>
            <div>
              <label className="font-semibold">Payment Reference / UTR</label>
              <input name="utr" className="mt-1 w-full rounded-xl border px-3 py-2" placeholder="Transaction ID" />
            </div>
            <div className="md:col-span-2">
              <label className="font-semibold">Upload Supporting Documents</label>
              <input name="files" type="file" multiple className="mt-1 w-full rounded-xl border px-3 py-2" />
              <p className="text-xs text-slate-500 mt-1">e.g., registration certificate, bylaws/constitution, list of member hospitals</p>
            </div>
            <div className="md:col-span-2 flex items-start gap-2">
              <input type="checkbox" name="declare" className="mt-1" />
              <p className="text-sm">I declare the information is true and agree to abide by the Federation’s constitution and code of conduct.</p>
            </div>
            <div className="md:col-span-2 flex gap-3">
              <button type="submit" className="rounded-xl bg-gradient-to-r from-blue-600 to-emerald-500 text-white px-5 py-2.5 font-semibold">Submit Application</button>
              <button type="button" onClick={printForm} className="rounded-xl border px-5 py-2.5 font-semibold">Print / Save PDF</button>
              <div className="ml-auto text-sm text-slate-600">Calculated fee: <span className="font-bold">₹{fee.toLocaleString()}</span></div>
            </div>
          </form>
        </Card>
      </Section>

      {/* NEWS */}
      <Section id="news" title="News" subtitle="Updates from federation and districts.">
        <div className="grid md:grid-cols-3 gap-4">
          {[1,2,3].map(n => (
            <Card key={n} className="p-4 hover:shadow-md">
              <div className="text-xs text-slate-500">{year}-0{n}-15</div>
              <h3 className="text-lg font-extrabold mt-1">Federation announcement #{n}</h3>
              <p className="text-slate-700 mt-2">Brief update text. Replace with live news integration.</p>
              <a className="inline-flex mt-3 text-blue-700 font-semibold hover:underline" href="#">Read more →</a>
            </Card>
          ))}
        </div>
      </Section>

      {/* ACTIVITIES */}
      <Section id="activities" title="Activities" subtitle="Key federation initiatives.">
        <div className="grid md:grid-cols-3 gap-4">
          <Card className="p-4">Policy & Advocacy Cell – drafts representations and coordinates with state authorities.</Card>
          <Card className="p-4">Quality & Accreditation – NABH awareness, peer reviews, infection control drives.</Card>
          <Card className="p-4">Digital Health & Data – interoperability, registries, analytics for outcomes.</Card>
        </div>
      </Section>

      {/* INSURANCE */}
      <Section id="insurance" title="Health Insurance" subtitle="Engagement with payors and TPAs.">
        <Card className="p-6">
          <ul className="list-disc ml-5 text-slate-800 space-y-2">
            <li>Standard templates for pre-auth, discharge, payments.</li>
            <li>Model tariff schedules and bundled packages.</li>
            <li>Escalation pathways and dispute resolution.</li>
            <li>Workgroups for cashless networks and fraud prevention.</li>
          </ul>
        </Card>
      </Section>

      {/* CEA */}
      <Section id="cea" title="Clinical Establishments Act (CEA)" subtitle="Support for compliance and advocacy.">
        <Card className="p-6">
          <ul className="list-disc ml-5 text-slate-800 space-y-2">
            <li>Guidance notes and checklists for hospitals.</li>
            <li>Consolidated feedback to authorities.</li>
            <li>District-level helplines and peer support.</li>
            <li>Training on BMW, fire safety, HR, etc.</li>
          </ul>
        </Card>
      </Section>

      {/* FOOTER */}
      <footer className="border-t mt-10 bg-white/70 backdrop-blur">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-3 gap-8">
          <div>
            <div className="font-extrabold">GAHNA</div>
            <div className="text-sm text-slate-600 mt-1">Gujarat Association of Hospitals, Nursing Homes & Allied Healthcare</div>
            <p className="text-sm text-slate-600 mt-3">© {year} • All rights reserved.</p>
          </div>
          <div>
            <div className="font-bold">Quick Links</div>
            <ul className="mt-2 text-sm space-y-1">
              <li><a href="#vision" className="hover:underline">Vision</a></li>
              <li><a href="#mission" className="hover:underline">Mission</a></li>
              <li><a href="#forms" className="hover:underline">Membership Form</a></li>
              <li><a href="#cea" className="hover:underline">CEA</a></li>
            </ul>
          </div>
          <div>
            <div className="font-bold">Contact</div>
            <p className="text-sm text-slate-600 mt-2">Secretariat (proposed)<br/>Email: info@example.org • Phone: +91-XXXXXXXXXX</p>
            <div className="text-xs text-slate-500 mt-3">This is a working prototype. Replace placeholder text & contacts before launch.</div>
          </div>
        </div>
      </footer>

      {/* FLOATING CTA */}
      <a href="#forms" className="fixed bottom-6 right-6 z-40 rounded-full px-5 py-3 shadow-lg bg-gradient-to-r from-blue-600 to-emerald-500 text-white font-semibold hover:opacity-95">
        Join Now
      </a>
    </div>
  );
}
